// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"649":"e77b6180","948":"a7136a19"}[chunkId] + ".js";
};